import { Autocomplete, Backdrop, Box, Button, CircularProgress, Container, FormControl, Grid, InputBase, InputLabel, MenuItem, Paper, Select, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import api from './../../../../Apis'
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import Swal from "sweetalert2";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import BuildScript from "./Components/BuildScript";
import { useTranslation } from 'react-i18next'
import { useParams, useNavigate } from "react-router-dom";
import DialogSelectFanpages from "../Fanpages/Posts/Components/DialogSelectFanpages";
import BlockGroupActions from "./Components/BlockGroupActions";
import AddIcon from '@mui/icons-material/Add';

export default function ChatBot() {
    const navigate = useNavigate();
    const { t , i18n } = useTranslation();
    const { fanpage_id } = useParams();
    const [state, setState] = useState({
        data_api: {},
        fanpage_selected: '',
        block_groups: [],
        block_active: {},
        loading_page: true,
        filter_fanpage_selected: null
    })
    const [cookies, setCookie] = useCookies('is_login');

    useEffect(() => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + cookies.is_login
            },
            body: JSON.stringify({
                fanpage_id, 
                lang: i18n.language 
            })
        };
        fetch(api.get_data_chabot, requestOptions)
        .then(res => res.json())
        .then(
            (result) => {
                if (result.success) {
                    setState({
                        ...state,
                        data_api: result.data,
                        loading_page: false,
                        fanpage_selected: result.data.fanpage_selected.fanpage_id
                    })
                }
            }
        )
    }, [])

    const onChangeFanpage = (e, data) => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + cookies.is_login
            },
            body: JSON.stringify({
                fanpage_id: data.fanpage_id,
                lang: i18n.language
            })
        };
        fetch(api.change_fanpage_chatbot, requestOptions)
        .then(res => res.json())
        .then(
            (result) => {
                if (result.success) {
                    const data_api = {...state.data_api};
                    data_api.block_groups = result.data.block_groups;
                    data_api.fanpage_selected = result.data.fanpage_selected;
                    // setState({
                    //     ...state,
                    //     data_api: data_api,
                    //     fanpage_selected: data.fanpage_id,
                    //     block_active: {}
                    // })
                    setState((prevState) => ({
                        ...prevState,
                        data_api: data_api,
                        fanpage_selected: data.fanpage_id,
                        block_active: {}
                    }));
                    navigate(`/dashboard/${data.fanpage_id}/chatbot`)
                } else {
                    Swal.fire({
                        title: result.message,
                        timer: 1000,
                        icon: "error"
                    })
                }
            }
        )
    }

    const addBlockGroup = () => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + cookies.is_login
            },
            body: JSON.stringify({
                fanpage_id: state.data_api.fanpage_selected.fanpage_id,
                lang: i18n.language
            })
        };
        fetch(api.create_block_group, requestOptions)
        .then(res => res.json())
        .then(
            (result) => {
                if (result.success) {
                    const data_api = {...state.data_api};
                    data_api.block_groups = [...data_api.block_groups, result.data];
                    setState({
                        ...state,
                        data_api: data_api
                    })
                } else {
                    Swal.fire({
                        title: result.message,
                        icon: 'error',
                        timer: 1500
                    })
                }
            }
        )
    }

    const addBlock = (data, index) => {
        const rand = Math.random().toString().slice(2,13);
        const data_api = {...state.data_api};
        data_api.block_groups[index].blocks = [...data_api.block_groups[index].blocks, {name: 'Block ' + rand, 'code': rand}];
        setState({
            ...state,
            data_api: data_api
        })
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + cookies.is_login
            },
            body: JSON.stringify({
                block_group_code: data.code,
                name: 'Block ' + rand,
                code: rand,
                lang: i18n.language
            })
        };
        fetch(api.create_block, requestOptions)
        .then(res => res.json())
        .then(
            (result) => {
                if (!result.success) {
                    data_api.block_groups[index].blocks.pop();
                    setState({
                        ...state,
                        data_api: data_api
                    })
                    Swal.fire({
                        title: result.message,
                        icon: 'warning'
                    })
                }
            }
        )
    }

    const changeNameBlockGroup = (e, value) => {
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + cookies.is_login
            },
            body: JSON.stringify({
                code: value.code,
                name: e.target.value,
                lang: i18n.language
            })
        };
        fetch(api.block_group_update, requestOptions)
        .then(res => res.json())
        .then(
            (result) => {
                if (!result.success) {
                    Swal.fire({
                        title: result.message,
                        icon: 'error',
                        timer: 1500
                    })
                }
            }
        )
    }

    const onChangeBlockActive = (blockItem, index, index_child) => {
        blockItem['index_parent'] = index;
        blockItem['index_child'] = index_child;
        setState({...state, block_active: blockItem});
    }

    const updateNameBlockFromProps = (new_name, block) => {
        const data_api = {...state.data_api};
        data_api.block_groups[block.index_parent].blocks[block.index_child].name = new_name;
        setState({
            ...state,
            data_api: data_api
        })
    }

    const deleteBlockGroup = (data, index) => {
        Swal.fire({
            title: t("common.alert.confirmDelete"),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t("common.alert.confirm"),
            cancelButtonText: t("common.alert.cancel")
        }).then((result) => {
            if (result.isConfirmed) {
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + cookies.is_login
                    },
                    body: JSON.stringify({
                        code: data.code,
                        lang: i18n.language
                    })
                };
                fetch(api.block_group_delete, requestOptions)
                .then(res => res.json())
                .then(
                    (result) => {
                        if (result.success) {
                            Swal.fire({
                                title: t("common.alert.deleteSuccess"),
                                icon: "success",
                            })
                            const data_api = {...state.data_api};
                            data_api.block_groups.splice(index, 1);
                            setState({
                                ...state,
                                data_api: data_api
                            })
                        } else {
                            Swal.fire({
                                title: result.message,
                                icon: "error",
                                timer: 1000
                            })
                        }
                    }
                )
            }
        })
    }    
    return (
        <div>
            {
                state.loading_page
                ?
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={state.loading_page}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
                :
                <Container maxWidth="xl" className='m-t-40'>
                    <Grid item xs={12} md={12}>
                        <h3>{t("chatbot.setupChatbotScript")}</h3>
                    </Grid>
                    <Grid container spacing={8}>
                        <Grid item xs={3}>
                            {/* <Grid container spacing={2}> */}
                                {/* <Grid item xs={4}> */}
                                    <FormControl fullWidth sx={{mb: 3}}>
                                        {/* <InputLabel id="demo-simple-select-label">Chọn Fanpage</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            defaultValue={state.data_api.fanpage_selected != undefined ? state.data_api.fanpage_selected.fanpage_id : ''}
                                            onChange={onChangeFanpage}
                                            label="Chọn Fanpage"
                                        >
                                            {
                                                state.data_api?.fanpages?.map((value, key) => {
                                                    return (
                                                        <MenuItem value={value.fanpage_id}>{value.name}</MenuItem>
                                                    )
                                                })
                                            }
                                        </Select> */}
                                        {/* <Autocomplete
                                            id="tags-outlined"
                                            options={state.data_api?.fanpages}
                                            getOptionLabel={(option) => `${option.name} - ${option.fanpage_id}`}
                                            // defaultValue={state.data_api.fanpage_selected != undefined && state.data_api.fanpage_selected}
                                            defaultValue={state.data_api?.fanpages && state.data_api?.fanpages.find((fanpage) => fanpage.fanpage_id === fanpage_id)}
                                            onChange={onChangeFanpage}
                                            filterSelectedOptions
                                            size="small"
                                            renderInput={(params) => (
                                            <TextField
                                                size="small"
                                                {...params}
                                                label={t("chatbot.selectFanpage")}
                                            />
                                            )}
                                        /> */}
                                        <Box sx={{display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap"}}>
                                            <DialogSelectFanpages
                                                listFanpages={state.data_api?.fanpages || []}
                                                fanpageSelected={state.filter_fanpage_selected || []}
                                                handleChangeFanpage={(value) => {
                                                    setState((prevState) => ({
                                                        ...prevState,
                                                        filter_fanpage_selected: value,
                                                    }));
                                                    onChangeFanpage(null, value?.[0]);
                                                }}
                                                // buttonSize='small'
                                                className="text-transform"
                                                multiple={false}
                                                buttonText={t("chatbot.selectFanpage")}
                                                icon={<AddIcon />}
                                            />
                                            {
                                                state.filter_fanpage_selected?.length > 0  && (
                                                    <Typography variant="body2" color={"error"}>
                                                        Đã chọn fanpage <strong>"{state.filter_fanpage_selected?.[0]?.name}"</strong>  
                                                    </Typography>
                                                )
                                            }
                                        </Box>
                                    </FormControl>
                                {/* </Grid> */}
                            {/* </Grid> */}
                            {/* <br></br> */}
                            {/* <Grid container spacing={8}> */}
                            {/* <Grid item xs={3}> */}
                                <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px'}}>
                                    <Typography variant="h3" sx={{fontSize: 16, fontWeight: "600"}}>{t('chatbot.blockList')}</Typography>
                                    <Button
                                        startIcon={<AddOutlinedIcon />}
                                        color="primary"
                                        variant="outlined"
                                        // fullWidth
                                        onClick={addBlockGroup}
                                        size="small"
                                        sx={{ borderRadius: '8px' }}
                                    >
                                        {t("chatbot.createNewBlockGroup")}
                                    </Button>
                                </Box>
                                <Box sx={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto', paddingRight: '8px' }}>
                                    {state.data_api?.block_groups?.length > 0 &&
                                        state.data_api?.block_groups?.map((value, index) => {
                                            return (
                                                <Box key={value.code || index} sx={{ marginBottom: '20px' }}>
                                                    <Paper
                                                        elevation={0}
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            padding: '8px 12px',
                                                            borderRadius: '8px',
                                                            transition: '0.3s',
                                                            backgroundColor: '#f5f5f5',
                                                        }}
                                                    >
                                                        <InputBase
                                                            defaultValue={value.name}
                                                            onBlur={(e) => changeNameBlockGroup(e, value)}
                                                            sx={{ 
                                                                flex: 1, 
                                                                color: 'inherit', 
                                                                fontWeight: '500',
                                                                '& .MuiInputBase-input': { padding: 0 },
                                                                '&:focus-within': {
                                                                    borderColor: '#1976d2',
                                                                    backgroundColor:'#fff',
                                                                    boxShadow: '0 0 0 2px rgba(25, 118, 210, 0.2)',
    } 
                                                            }}
                                                        />
                                                        <BlockGroupActions 
                                                            onAddBlock={() => addBlock(value, index)}
                                                            onDeleteGroup={() => deleteBlockGroup(value, index)}
                                                        />
                                                    </Paper>

                                                    <Box sx={{ paddingLeft: '24px', marginTop: '8px' }}>
                                                        <Grid container spacing={1}>
                                                            {value.blocks.map((blockItem, index_child) => (
                                                                <Grid item xs={12} key={blockItem.code || index_child}>
                                                                    <Button
                                                                        fullWidth
                                                                        variant={state.block_active?.code === blockItem.code ? "contained" : "text"}
                                                                        color={state.block_active?.code === blockItem.code ? "primary" : "inherit"}
                                                                        sx={{ 
                                                                            justifyContent: 'flex-start', 
                                                                            textTransform: 'none',
                                                                            textAlign: 'left'
                                                                        }}
                                                                        onClick={() => onChangeBlockActive(blockItem, index, index_child)}
                                                                    >
                                                                        {blockItem.name}
                                                                    </Button>
                                                                </Grid>
                                                            ))}
                                                        </Grid>
                                                    </Box>
                                                </Box>
                                            );
                                        })
                                    }
                                </Box>

                               
                            {/* </Grid> */}
                                {/* <Grid item xs={1}></Grid> */}
                            {/* </Grid> */}
                        </Grid>
                        
                        <BuildScript
                            key={state.block_active.code}
                            block_active={state.block_active}
                            cookie={cookies.is_login}
                            updateNameBlockFromProps={updateNameBlockFromProps}
                            fanpage_id={state.data_api?.fanpage_selected?.fanpage_id}
                        />
                    </Grid>
                </Container>
            }
            
        </div>
        
    )
}

